jQuery(document).ready(function ($) {
  $(".btn-menu").on("click", function () {
    $(".wrapMobileBar").toggleClass("active");
  });

  $(".overlaySidebarMobile").on("click", function () {
    $(".wrapMobileBar").toggleClass("active");
  });

  $(".btn-close-menu").on("click", function () {
    $(".wrapMobileBar").toggleClass("active");
  });

  if ($(".js-comment-content").length > 0) {
    window.maxCmt = 0;
    $(".js-comment-content").each(function (key, item) {
      if ($(item).outerHeight() > maxCmt) {
        window.maxCmt = $(item).height();
      }
    });

    $(".js-comment-content").height(maxCmt);
  }

  $(".more-btn").each(function () {
    var btn = $(this),
      parent = btn.parent(),
      dots = parent.find(".dots"),
      moreText = parent.find(".more-text"),
      less = btn.data("less"),
      more = btn.data("more");

    btn.on("click", function (e) {
      e.preventDefault();
      dots.toggleClass("d-none");
      moreText.toggleClass("d-none");
      if (btn.hasClass("more")) {
        btn.removeClass("more").text(more);
        if (parent.hasClass("js-comment-content")) {
          parent.height(maxCmt);
        }
        return;
      }

      btn.addClass("more").text(less);
      if (parent.hasClass("js-comment-content")) {
        parent.removeAttr("style");
      }
    });
  });

  $(document.body).on("adding_to_cart", function (e, $thisbutton) {
    $thisbutton.prepend(`<i class="fas fa-spinner fa-spin"></i>`);
  });
  $(document.body).on("added_to_cart", function (e, fragments, cart_hash, $thisbutton) {
    $thisbutton.find("i").removeClass("fas fa-spinner fa-spin").addClass("far fa-check-circle");
    setTimeout(function () {
      $thisbutton.find("i").remove();
    }, 1000);
  });
});
